export enum AnsweringAutomation {
  CAIA = 'CAIA',
  MANUAL = 'Manual',
  LLM = 'LLM',
  GPT = 'GPT',
}
